const initialState = {
  accesstype: 'PRIVILEGEDACCESS',
  requestor: '',
  requestedfor: '',
  comments: '',
  sessions: [
    {
      accountId: null,
      businessjustification: null,
      startdate: null,
      enddate: null,
    },
  ],
  pamtype: 'credentials',
};

export const credentialRequestFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'requestor': {
      return {
        ...state,
        requestor: action.payload,
      };
    }

    case 'requestedFor': {
      return {
        ...state,
        requestedfor: action.payload,
      };
    }

    case 'accountId': {
      return {
        ...state,
        sessions: [{ ...state.sessions[0], accountId: action.payload }],
      };
    }

    case 'businessJustification': {
      return {
        ...state,
        sessions: [
          { ...state.sessions[0], businessjustification: action.payload },
        ],
      };
    }

    case 'dateRange': {
      return {
        ...state,
        sessions: [
          {
            ...state.sessions[0],
            startdate: action.payload.start,
            enddate: action.payload.end,
          },
        ],
      };
    }

    default:
      return state;
  }
};

export default credentialRequestFormReducer;
